export const jaDeals = {};